import SendEmailList from '@/views/App/SendEmail/List.vue';
import SendEmailDetails from "@/views/App/SendEmail/Details.vue";
const routesSendEmail = [
    {
        path: 'list',
        name: 'sendEmailList',
        component: SendEmailList
    },
    {
        path: 'details/:id?',
        name: 'sendEmailDetails',
        component: SendEmailDetails
    },
];

export default routesSendEmail;